(function () {
  function initProductCardHover() {
    const buttonSelectors = ['#product-card-btn'];

    const hoverStyles = `
        background-color: #1dce60 !important;
        color: white !important;
        transition: all 0.3s ease !important;
        border-color: #1dce60 !important;
      `;

    function findButton(element) {
      for (let selector of buttonSelectors) {
        const button = element.querySelector(selector);
        if (button) return button;
      }
      return null;
    }

    function handleHover(event, shouldApplyStyle) {
      const button = findButton(event.currentTarget);
      if (button) {
        button.setAttribute('style', shouldApplyStyle ? hoverStyles : '');
      }
    }

    const items = document.querySelectorAll('.grid__item');
    items.forEach((item) => {
      item.addEventListener('mouseenter', (e) => handleHover(e, true));
      item.addEventListener('mouseleave', (e) => handleHover(e, false));
    });
    console.log('initProductCardHover');
  }

  // Use a more robust method to run the script after DOM is ready
  if (typeof jQuery !== 'undefined') {
    jQuery(document).ready(initProductCardHover);
  } else {
    window.addEventListener('load', initProductCardHover);
  }
})();
